import React,{useEffect} from 'react'
import { Link } from 'react-router-dom'
import Header from'../Component/Header'
import Footer from'../Component/Footer'
const EntranceExamination = () => {
     useEffect(() => {
        document.title = 'XI Class Enterance Test Result -  St Peters convent School Faridabad Haryana';  
    }, []); 
  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link>{" "}
            
          </li>
          <li>  Admission  </li>
          <li>Interaction and Entrance Examination Result </li>
        </ul>
      </div>
      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1>XI Class Enterance Test Result   </h1>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <h3> XI Class Enterance Test Result - 8th November 2025. </h3>

               
              <div className="table-responsive maintable">
                <table className="table">
                  <thead>
                    <tr>
                    <th>S.NO </th>
                    <th>	CHILD'S NAME  </th>
                    <th>	REG. NO.  </th>
                    <th>	CLASS </th> 
                    <th>	SCHOOL </th> 
                    
                    </tr>
                  </thead>
                  <tbody>
                  <tr>
                  <td>1</td>
                  <td>SHUBHAM CHOUDHARY</td>
                  <td>XI 1046</td>
                  <td>X-C</td>
                  <td>SEC-88, ST. PETER'S</td>
              </tr>
              <tr>
                  <td>2</td>
                  <td>DEVANSH PARASHAR</td>
                  <td>XI 1016</td>
                  <td>X-C</td>
                  <td>SEC-88, ST. PETER'S</td>
              </tr>
              <tr>
                  <td>3</td>
                  <td>DEVANSH SINGH</td>
                  <td>XI 1007</td>
                  <td>X-C</td>
                  <td>SEC-88, ST. PETER'S</td>
              </tr>
              <tr>
                  <td>4</td>
                  <td>PRABHJOT SINGH</td>
                  <td>XI 1047</td>
                  <td>X-A</td>
                  <td>SEC-88, ST. PETER'S</td>
              </tr>
              <tr>
                  <td>5</td>
                  <td>KARTIK NEGI</td>
                  <td>XI 1022</td>
                  <td>X-C</td>
                  <td>SEC-88, ST. PETER'S</td>
              </tr>
              <tr>
                  <td>6</td>
                  <td>GEETANSHI YADAV</td>
                  <td>XI 1035</td>
                  <td>X-C</td>
                  <td>SEC-88, ST. PETER'S</td>
              </tr>
              <tr>
                  <td>7</td>
                  <td>LAKSH GUPTA</td>
                  <td>XI 1075</td>
                  <td>X</td>
                  <td>SEC 16A</td>
              </tr>
              <tr>
                  <td>8</td>
                  <td>KUNSH SHARMA</td>
                  <td>XI 1012</td>
                  <td>X-C</td>
                  <td>SEC-88, ST. PETER'S</td>
              </tr>
                  </tbody>
                </table>
              </div> 
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default EntranceExamination
